import { FC, useEffect } from 'react';
import { Container, Button, Typography, Stack } from '@mui/material';
import { captureException, captureMessage } from '@sentry/react';

export const SentryDebug: FC = () => {
  const throwErrorInEffect = () => {
    throw new Error('Sentry debug error in useEffect - this will be caught by error boundary');
  };

  const throwErrorInHandler = () => {
    throw new Error('Sentry debug error in event handler - this bypasses error boundary');
  };

  const captureManualException = () => {
    captureException(new Error('Manual Sentry exception capture'));
  };

  const captureManualMessage = () => {
    captureMessage('Manual Sentry message capture', 'info');
  };

  useEffect(() => {
    console.log('Sentry Debug component mounted');
    console.log('Sentry DSN:', process.env.NX_SENTRY_DSN_FRONTEND ? 'configured' : 'not configured');
    console.log('Environment:', process.env.NX_ENVIRONMENT);
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Sentry Debug
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Test different ways to trigger Sentry error reporting:
      </Typography>
      
      <Stack spacing={2} direction="column">
        <Button 
          variant="contained" 
          color="error" 
          onClick={throwErrorInHandler}
        >
          Throw Error in Handler (bypasses error boundary)
        </Button>
        
        <Button 
          variant="contained" 
          color="warning" 
          onClick={captureManualException}
        >
          Manual Exception Capture
        </Button>
        
        <Button 
          variant="contained" 
          color="info" 
          onClick={captureManualMessage}
        >
          Manual Message Capture
        </Button>
        
        <Button 
          variant="outlined" 
          color="error" 
          onClick={throwErrorInEffect}
        >
          Throw Error in Effect (caught by error boundary)
        </Button>
      </Stack>
      
      <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
        DSN Status: {process.env.NX_SENTRY_DSN_FRONTEND ? 'Configured' : 'Not configured'}
        <br />
        Environment: {process.env.NX_ENVIRONMENT || 'Not set'}
      </Typography>
    </Container>
  );
};